/* eslint-disable import/prefer-default-export */
import Feature from './Feature.class.js'

export {
  Feature,
}
